import { Routes as reportRoutes } from "../report";

export const Routes = () => {
  return reportRoutes;
};
